import { SEASONAL_FEATURED_GET_SUCCESS, SEASONAL_FEATURED_GET_FAILURE } from '../actions/types';
import seasonalFeaturedConfig from '../configs';

/** @type {{config: object, placements: array.<object>}} */
const initialState = {
  config: seasonalFeaturedConfig,
  placements: [],
  isLoading: false,
  isLoaded: false,
};

/**
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
const seasonalFeatured = (state = initialState, action) => {
  switch (action.type) {
    case SEASONAL_FEATURED_GET_SUCCESS: {
      const placements = action.payload.response;
      return {
        ...state,
        placements,
        isLoading: false,
        isLoaded: true,
      };
    }
    case SEASONAL_FEATURED_GET_FAILURE: {
      return {
        ...state,
        placements: [],
        isLoading: false,
        isLoaded: true,
      }; // we'd have to decide what to do with error state
    }
    default: {
      const { options = {} } = action;
      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === SEASONAL_FEATURED_GET_SUCCESS) {
        return { ...state, isLoading: true };
      }

      return state;
    }
  }
};

export default seasonalFeatured;
